import { render, staticRenderFns } from "./job.vue?vue&type=template&id=56df12c8&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56df12c8')) {
      api.createRecord('56df12c8', component.options)
    } else {
      api.reload('56df12c8', component.options)
    }
    module.hot.accept("./job.vue?vue&type=template&id=56df12c8&", function () {
      api.rerender('56df12c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/peopleVerify/components/job.vue"
export default component.exports